export const result = [
  {
    title: '公司实力（参考标准：门店规模、资金实力、核心团队、品牌知名度）',
    options: {
      labels: [],
      values: []
    }
  },
  {
    title:
      '薪酬福利（参考标准：基本工资、课时费、绩效考核、食宿支持、五险一金、带薪假期）',
    options: {
      labels: [],
      values: []
    }
  },
  {
    title:
      '成长空间（参考标准：职业晋升、内训机制、培训费用、海外游学、多元化发展）',
    options: {
      labels: [],
      values: []
    }
  },
  {
    title:
      '企业文化（参考标准：愿景使命、开放度、男女比例、国际化、工作环境、团建费用）',
    options: {
      labels: [],
      values: []
    }
  }
]
